export const BOOTSTRAP_REQUEST = 'BOOTSTRAP_REQUEST';
export const BOOTSTRAP_SUCCESS = 'BOOTSTRAP_SUCCESS';
export const BOOTSTRAP_FAILURE = 'BOOTSTRAP_FAILURE';
export const BOOTSTRAP_INITIAL_LOAD = 'BOOTSTRAP_INITIAL_LOAD';
